/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPaymentStatusOutput } from "../../entities/models/PaymentStatusOutput";
import { z } from "zod/v4";

export const modelsPaymentStatusOutputSchema = z.object({
    "amount": z.optional(z.number()),
"paid": z.optional(z.boolean()),
"paid_at": z.optional(z.string()),
"payment_id": z.optional(z.int()),
"status": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsPaymentStatusOutput>